module.exports = __webpack_public_path__ + "img/consult_info2.04dc976b.png";